import { http } from '../utils/http';

// 登录接口
export function login(data) {
  return http.post('/sso/api/Account/SignIn', data);
}

// 退出登录接口
export function logout(params = {}) {
  return http.get('/sso/api/Account/SignOut', { params });
}

// 获取用户信息接口
export function getUserInfo(appCode = 'erp') {
  return http.get('/sso/api/Account/GetUserInfo', { params: { appCode } });
}

// 获取菜单列表接口
export function getMenuList() {
  return http.get('/api/user/menu');
}